import { getLocalizedMessage, showMessageAlert } from '@/core/shared'
import { bindResetButtonModal } from '@/core/input_controls/button/button'

export function TagManager (global, companyId) {
	this.global = global
	this.companyId = companyId
	this.tags = []

	this.initTagManager = function () {
		var self = this
		Swal.fire({
			title: getLocalizedMessage('tags'),
			html: '<div class="modal_item">\n' +
				'    <label for="tag_name">' + getLocalizedMessage('name') + '</label>\n' +
				'    <br>\n' +
				'    <input id="tag_name" class="textInput attribute-editor" type="text">\n' +
				'    <button class="button_reset fa fa-times"></button>\n' +
				'</div>',
			confirmButtonText: getLocalizedMessage('save'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowOutsideClick: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				content: 'form',
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				bindResetButtonModal()
			},
			preConfirm: function () {
				var tagFieldValue = document.getElementById('tag_name').value
				return tagFieldValue
			}
		}).then(function (result) {
			if (result.value) {
				if (self.global) {
					self.saveTag({ 'name': result.value })
				} else {
					self.saveTag({
						'name': result.value,
						'companyId': self.companyId
					})
				}
			}
		})
	}

	this.setCompanyId = function (id) {
		this.companyId = id
	}

	this.saveTag = function (data) {
		var self = this
		var prefix = self.global ? 'global/' : 'company/'
		$.ajax({
			url: window.urlContext + prefix + 'tags/create',
			type: 'POST',
			contentType: 'application/json; charset=UTF-8',
			async: true,
			context: this,
			data: JSON.stringify(data),
			success: function (data) {
				self.getTags()
				$('#tag-name').val('')
				showMessageAlert(getLocalizedMessage('changes.saved'), 'success')
			},
			error: function () {
				showMessageAlert(getLocalizedMessage('error.saving'), 'danger')
			}
		})
	}

	this.getTags = function (callback) {
		var self = this
		var prefix = self.global ? 'global/' : ''
		$.ajax({
			url: window.urlContext + prefix + 'tags',
			type: 'GET',
			async: true,
			context: this,
			success: function (data) {
				self.tags = data
				$('#migration-new-tag-name').val('')
				self.updateTagList()
				if (typeof callback === 'function') {
					callback()
				}
			}
		})
	}

	this.updateTagList = function () {
		var $el = $('#transformation-tag')
		$el.empty()
		$el.append($('<option></option>').attr('value', null).text(''))
		$.each(this.tags, function (key, value) {
			$el.append($('<option></option>').attr('value', value['id']).text(value['name']))
		})
	}
}
